import { emailValidation, hideValidationMessage, phoneValidationWithoutPlus, showValidationMessage } from "../../form-validation-message";

export const inputRMOValidation = (inputEl, moNumbers) => {
  const id = inputEl.id;
  let error = false;

  if (inputEl.value === "" || inputEl.value === undefined) {
    showValidationMessage(inputEl);
    error = true;
  } else {
    hideValidationMessage(inputEl);
  }

  if (id.includes("mo-number")) {
    const value = inputEl.value;
    error = true;
    let index = id.replace("wu-input-mo-number-", "");
    index = index.includes("wu-input") ? 0 : index;
    if (!/^\d+$/.test(value) || !value) {
      showValidationMessage(
        inputEl,
        "data-error-message"
      );
      inputEl.value = inputEl.value.substring(0, 11);
      return true;
    } else if (value?.length < 11) {
      showValidationMessage(
        inputEl,
        "data-error-message"
      );
      return true;
    } else if (value?.length > 11) {
      inputEl.value = inputEl.value.substring(0, 11);
      return true;
    } else if (
      moNumbers[index] !== "" &&
      moNumbers[index] !== inputEl.value &&
      moNumbers.indexOf(inputEl.value) !== -1
    ) {
      delete moNumbers[index];
      showValidationMessage(
        inputEl,
        "data-same-error-message"
      );
      return true;
    } else {
      error = false;
      hideValidationMessage(inputEl);
    }
    moNumbers[index] = inputEl.value;
  }
  if (inputEl.classList.contains("contact-info-email-id")) {
    if (!emailValidation(inputEl)) {
      showValidationMessage(inputEl);
      error = true;
    } else {
      hideValidationMessage(inputEl);
    }
  }

  if (inputEl.classList.contains("contact-info-phone-number")) {
    if (!phoneValidationWithoutPlus(inputEl)) {
      showValidationMessage(inputEl);
      error = true;
    } else {
      hideValidationMessage(inputEl);
    }
  } else if (inputEl.id.includes("wu-input-mo-amount")) {
    if (inputEl.value === "" || inputEl.value < 0) {
      inputEl.value = "";
      showValidationMessage(inputEl, 'default-message');
      error = true;
    }else if(inputEl.value > 3000) {
      showValidationMessage(inputEl, 'max-limit-message');
      error = true;
    } else {
      hideValidationMessage(inputEl);
    }
    const splitMoAmountOnDecimal = inputEl.value.split(".")
    if (splitMoAmountOnDecimal[1] && splitMoAmountOnDecimal[1].length >= 3) {
      inputEl.value = roundToTwo(inputEl.value);
    }
  } else if(inputEl.id === 'wu-input-zip-code') {
    const countryDropdownContact = document.querySelector('#country-dropdown-contact')
    const countrySlug = countryDropdownContact.getAttribute('data-slug')?.toUpperCase()  || 'US'
    if (!isValidPostalCode(inputEl.value, countrySlug)) {
      showValidationMessage(inputEl);
      error = true;
    } else {
      hideValidationMessage(inputEl);
    }
  } else if (inputEl.id === "contact-first-name" || inputEl.id === "contact-last-name") {
    let dataNameRegex = new RegExp(inputEl.getAttribute('data-name-regex'))
    if (!dataNameRegex.test(inputEl.value)) {
      showValidationMessage(inputEl, inputEl.value ? 'data-letter-error' : 'data-general-error');
      error = true;
    } else {
      hideValidationMessage(inputEl);
    }
  }
  return error;
};
